<template>
  <div class="introduce">
    <p align="center">暂无相关信息1</p>
  </div>
</template>

<script>
export default {
  name: "15introduce",
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
